export const COLLECT_INIT_WIDTH = 7.83

export const COLLECT_EXPEND_WIDTH = 12

export const PAGE_SIZE = 20

export const GTM_FREEBLE = "freeble"

export const GTM_REDEMPTION = "redemption"
